import useContent from "@lib/use_content";
import Label from "@hudson/ui/components/FormFields/HtmlLabel";

function ProfileHeader({}) {
  const { data, loading } = useContent(["landingMessage", "logo", "logo2"]);

  return data?.content.logo || data?.content.landingMessage ? (
    <div className="flex flex-col items-center gap-6 mb-4">
      <div
        className={`${data?.content.logo && data?.content.logo2 ? "grid grid-cols-1 normal:grid-cols-2 gap-8 justify-items-center" : ""}`}
      >
        {data.content.logo && (
          <img
            src={data.content.logo}
            className="w-full h-full normal:h-full object-center object-scale-down max-h-32"
          />
        )}
        {data.content.logo2 && (
          <img
            src={data.content.logo2}
            className="w-full h-full normal:h-full object-center object-scale-down max-h-32"
          />
        )}
      </div>
      <div className="max-w-3xl mb-4 ">
        <Label text={data?.content.landingMessage} />
      </div>
    </div>
  ) : null;
}

export default ProfileHeader;
